import { Container } from 'react-awesome-styled-grid'

import { Button } from '@superlogica/button'
import styled from 'styled-components'

import media from '../../utils/media'
import Card from '../shared/Card'
import Title from '../shared/Title'

export const ConversionBoxContainer = styled(Container)`
  ${media.lessThan('sm')`
    padding: 0;
  `}
`

export const ConversionBoxWrapper = styled(Card)`
  .shape-line-circle {
    top: -30px;
    left: 10%;
  }

  .shape-half-circle {
    bottom: -30px;
    right: 10%;
  }

  ${media.lessThan('sm')`
    border-radius: 0;
    padding: 80px 24px;

    .shape-line-circle {
      top: 60px;
      left: -20px;
      transform: rotate(20deg);
    }

    .shape-half-circle {
      right: 5px;
    }
  `}
`

export const ConversionBoxContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  position: relative;
  z-index: 2;
`

export const ConversionTitle = styled(Title)`
  margin-bottom: 32px;

  span {
    color: ${({ theme }) => theme.color.yellow500};
  }
`

export const ConversionButtonGroup = styled.div`
  width: 100%;
`

export const ConversionButton = styled(Button)`
  ${media.greaterThan('xs')`
    margin-left: 8px;
    margin-right: 8px;
  `}

  ${media.lessThan('sm')`
    &:not(:last-of-type) {
      margin-bottom: 12px;
    }
  `}
`

export const ConversionIllustration = styled.div`
  position: absolute;
  bottom: -150px;
  left: -75px;
  z-index: 1;
  opacity: 0.1;
  width: 300px;
  height: 300px;

  ${media.lessThan('xs')`
    /* width: 50%; */
  `}
`
